import React, { useState, useContext } from "react";
import * as M from "./ModalStyle";
import PDFGenerator from "./PDFGenerator";
import { AuthContext } from "../../../context/AuthContext";
import Loading from "../../Loading/Loader";
import { useMessage } from "../../../context/MessageContext";
import { contractService } from "../../../Services/contractService"; // Importando o serviço

export default function Modal({
  modalData,
  handleModalCompra,
  onPurchaseSuccess,
}) {
  const { userData } = useContext(AuthContext);
  const { showMessage } = useMessage();
  const [assinatura, setAssinatura] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (event) => {
    setAssinatura(event.target.checked ? "assinado" : "");
  };

  const handleConfirmarCompra = async () => {
    if (assinatura !== "assinado") {
      showMessage("Por favor, assine o contrato para continuar.", "warning");
      return;
    }
    setLoading(true);
    const requestData = {
      clientId: userData.id,
      contractQtt: parseFloat(modalData.qttContratos),
    };
    try {
      // Usando o contractService
      await contractService.purchaseContract(requestData);
      showMessage(`Compra de ${requestData.contractQtt} contratos registrada!`, "success");
      onPurchaseSuccess(); // Chama a função de sucesso para recarregar os dados
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Ocorreu um erro ao processar sua compra.";
      showMessage(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    // O JSX permanece o mesmo
    <M.ModalContainer>
      <M.ModalBox>
        {loading && <M.LoadingBuy><Loading load={loading} /></M.LoadingBuy>}
        <M.FecharModalBtn><span onClick={handleModalCompra}>Fechar e Cancelar</span></M.FecharModalBtn>
        <M.ModalPDFContainer>
          <PDFGenerator ContratoData={modalData} assinatura={assinatura} />
        </M.ModalPDFContainer>
        <M.CheckboxContainer>
          <label>
            <input type="checkbox" onChange={handleCheckboxChange} checked={assinatura === "assinado"} />
            Li e concordo com os termos. Assinar contrato.
          </label>
        </M.CheckboxContainer>
        <M.ConfirmacaoDeCadastro>
          <button onClick={handleConfirmarCompra}>CONFIRMAR E COMPRAR</button>
        </M.ConfirmacaoDeCadastro>
      </M.ModalBox>
    </M.ModalContainer>
  );
}